import { currentOrganization } from '@fastlessjs/backoffice-layer/dist/hooks';

import { Trace } from '../types';

export const isPendingTrace = (record?: Partial<Trace>): boolean =>
  record?.displayReturnStatus === 'pending' || record?.returnStatus === 'pending';

export const getTraceListItemPath = (record: Partial<Trace>): string =>
  `suivi/${record.suiviId}/view`;

/** Same path shape as Listing `itemUrl.view` — resolved from the current /:org/suivi route. */
export const getTraceDetailNavigatePath = (record: Partial<Trace>): string => {
  const org = currentOrganization()?.organizationId?.toLowerCase() || '';
  if (!org || !record.suiviId) {
    return getTraceListItemPath(record);
  }
  return `/${org}/${getTraceListItemPath(record)}`;
};

export const formatReturnStatusLabel = (
  returnStatus: string | undefined,
  labels: Record<string, string>,
): string => {
  if (!returnStatus) {
    return labels.confirmed || returnStatus || '';
  }
  return labels[returnStatus] || returnStatus;
};
